import { render } from "./ThisweekPage.vue?vue&type=template&id=77cef9ce"
import script from "./ThisweekPage.vue?vue&type=script&lang=js"
export * from "./ThisweekPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__